var map = {
	"./bak/en": [
		3896,
		3,
		896
	],
	"./bak/en.json": [
		3896,
		3,
		896
	],
	"./bak/hu": [
		9349,
		3,
		349
	],
	"./bak/hu.json": [
		9349,
		3,
		349
	],
	"./en": [
		790,
		3
	],
	"./en.json": [
		790,
		3
	],
	"./hu": [
		4626,
		3,
		626
	],
	"./hu.json": [
		4626,
		3,
		626
	],
	"./i18n": [
		9454,
		9
	],
	"./i18n.js": [
		9454,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 912;
module.exports = webpackAsyncContext;